/**
 * 生成默认头像的 data URI，避免外部 dicebear API 请求导致图片加载慢
 */

// 简单的字符串哈希，用于生成不同颜色
function hashStr(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return hash;
}

// 根据用户名生成颜色
const PALETTE = [
  ['#667eea', '#764ba2'],
  ['#f093fb', '#f5576c'],
  ['#4facfe', '#00f2fe'],
  ['#43e97b', '#38f9d7'],
  ['#fa709a', '#fee140'],
  ['#a18cd1', '#fbc2eb'],
  ['#fccb90', '#d57eeb'],
  ['#e0c3fc', '#8ec5fc'],
  ['#f5576c', '#ff6a88'],
  ['#667eea', '#43e97b'],
];

/**
 * 生成默认头像 data URI（SVG格式）
 * @param {string} username - 用户名
 * @returns {string} data URI
 */
export function getDefaultAvatar(username) {
  const nameStr = String(username || '?');
  const h = Math.abs(hashStr(nameStr === '?' ? 'default' : nameStr));
  const [c1, c2] = PALETTE[h % PALETTE.length];
  const initial = nameStr[0].toUpperCase();
  
  const svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">' +
    '<defs><linearGradient id="bg" x1="0%" y1="0%" x2="100%" y2="100%">' +
    '<stop offset="0%" stop-color="' + c1 + '"/>' +
    '<stop offset="100%" stop-color="' + c2 + '"/>' +
    '</linearGradient></defs>' +
    '<rect width="100" height="100" rx="12" fill="url(#bg)"/>' +
    '<text x="50" y="54" text-anchor="middle" dominant-baseline="central"' +
    ' font-family="system-ui,-apple-system,sans-serif"' +
    ' font-size="40" font-weight="600" fill="white">' + initial + '</text></svg>';
  
  return 'data:image/svg+xml,' + encodeURIComponent(svg);
}

/**
 * 生成封面占位图 URL（使用 picsum.photos 随机照片）
 * @param {string} title - 标题（用于固定种子，同标题同图片）
 * @param {number} w - 宽
 * @param {number} h - 高
 * @returns {string} 图片 URL
 */
export function getPlaceholderCover(title, w = 200, h = 94) {
  // 用标题哈希做种子，同地图每次拿到同一张图
  let seed = 0;
  const str = title || 'default';
  for (let i = 0; i < str.length; i++) seed = str.charCodeAt(i) + ((seed << 5) - seed);
  seed = Math.abs(seed);
  return 'https://picsum.photos/seed/' + seed + '/' + w + '/' + h;
}

/**
 * 生成封面兜底 SVG data URI（网络图片加载失败时使用）
 * @param {string} title - 标题
 * @param {number} w - 宽
 * @param {number} h - 高
 * @returns {string} data URI
 */
export function getFallbackCover(title, w = 200, h = 94) {
  const label = (title || '?')[0].toUpperCase();
  const svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + w + ' ' + h + '">' +
    '<rect width="' + w + '" height="' + h + '" fill="#1b2838"/>' +
    '<text x="' + (w/2) + '" y="' + (h/2) + '" text-anchor="middle" dominant-baseline="central"' +
    ' font-family="system-ui,sans-serif" font-size="' + Math.max(14, Math.min(28, w/10)) + '" fill="#66c0f4">' + label + '</text></svg>';
  return 'data:image/svg+xml,' + encodeURIComponent(svg);
}
